import { useSelector, useDispatch } from "react-redux";
import { useGetTransactionsDataQuery } from "../../../../store/queries/User";
import { updateConfig } from "../../../../store/slices/User/UserDetails/transactionSlice";
import { updateConfig as globalUpdateConfig } from "../../../../store/slices/Global";
import { useParams } from "react-router-dom";
import { useUpdateTransactionTableHeadDataMutation } from "../../../../store/queries/Admin";

const useTransactions = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const dispatch = useDispatch();
  const { user_id } = useParams();
  const activeProfile = user_id ?? sessionStorage.getItem("active");
  const transactionState = useSelector((state) => state.transaction);
  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const {
    data: transactionList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetTransactionsDataQuery({
    user_id: activeProfile,
    page_size: transactionState?.currentPageSize,
    page: transactionState?.currentPage,
    sort: transactionState?.sortBy,
    sort_order: transactionState?.sortOrder,
    search: transactionState?.search,
  });
  const [updateTransactionsFields] =
    useUpdateTransactionTableHeadDataMutation();

  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentPage = 1;
      })
    );
  };

  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };

  const handleSort = (label) => {
    if (transactionState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder =
            transactionState.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  return {
    isLoading,
    isFetching,
    tableFields,
    showEditModal,
    transactionList,
    paginationOptions,
    transactionState,
    updateTransactionsFields,
    handleEditColumnsClick,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  };
};

export default useTransactions;
